import { LocationInformation } from '../../../models/poData/LocationInformation';
import { TechZones } from '../../../models/assets-data/TechZonesConfig.interface';
import { formatDeliveryLocation } from './format-delivery-location';

/**
 * Resolves the shelf location for a receiving log based on the PO's location information.
 *
 * Service POs are shelved by technician zone: the technician team name is normalized
 * (lowercased, spaces replaced with dashes) and looked up in the tech zone config to find
 * a zone description. If no zone description exists, the formatted delivery location is
 * used as a fallback.
 *
 * @param locationInformation - Delivery location and technician team from the PO data.
 * @param techZones - Tech zone configuration (team-to-zone and zone-to-description maps).
 * @returns The resolved shelf location string.
 */
export function resolveShelfLocation(
  locationInformation: LocationInformation,
  techZones: TechZones
): string {
  const deliveryLocation = locationInformation.deliveryLocation;
  const techTeamFormatted = locationInformation.technicianTeam
    .toLowerCase()
    .replace(/\s+/g, '-');
  const zoneNumber = techZones.techTeams[techTeamFormatted];
  const zoneDescription = techZones.zones[zoneNumber];

  if (
    zoneDescription === undefined ||
    zoneDescription === null ||
    (zoneDescription === '' && deliveryLocation !== '')
  ) {
    return formatDeliveryLocation(deliveryLocation);
  }
  return zoneDescription;
}
